import { render, staticRenderFns } from "./zhiweigl.vue?vue&type=template&id=7017254d&scoped=true&"
import script from "./zhiweigl.vue?vue&type=script&lang=js&"
export * from "./zhiweigl.vue?vue&type=script&lang=js&"
import style0 from "./zhiweigl.vue?vue&type=style&index=0&id=7017254d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7017254d",
  null
  
)

export default component.exports